import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Container } from 'components/base';
import useDataContext from 'data/context/data';

import { money } from '../../lib/landingPrice';
import PdpIcon from '../product/pdpIcon';
import { GIFT_CARD_HREF } from './shared';
import { Responsive, SectionHead } from '../landing/shared';

// Gift note, envelopes, Gift Cards and order-by dates. Phones show one list.
const FinishingTouches = ({ track }) => {
  const envelopes = useDataContext().getProduct('square-envelopes');
  const envelopesPrice = envelopes && money(envelopes.prices[0], envelopes.currency);

  return (
    <section className="lnd-section gft-extras">
      <Container>
        <SectionHead
          eyebrow="The finishing touches"
          eyebrowClassName="lnd-eyebrow--green"
          title="Ready to give, straight out of the box"
        />
        <ul className="gft-extra-list">
          <li className="gft-extra">
            <span className="gft-extra-icon" aria-hidden="true">
              <PdpIcon name="penLine" size={22} />
            </span>
            <div className="gft-extra-copy">
              <h3 className="gft-extra-title">Add a gift note</h3>
              <p className="gft-extra-desc">
                <Responsive
                  desktop="Tick “Is this a gift?” at checkout. We print your message and pack it in the same box."
                  phone="We print your message and pack it in the same box. Added at checkout."
                />
              </p>
            </div>
            <span className="gft-extra-label">Added at checkout</span>
          </li>
          <li className="gft-extra">
            <span className="gft-extra-icon" aria-hidden="true">
              <PdpIcon name="mail" size={22} />
            </span>
            <div className="gft-extra-copy">
              <h3 className="gft-extra-title">
                <Anchor
                  href="/square-envelopes"
                  className="gft-extra-link"
                  onClick={track('extra', 'extras', 'square-envelopes')}
                >
                  Square Envelopes
                </Anchor>
              </h3>
              <p className="gft-extra-desc">
                <Responsive
                  desktop="Plain white envelopes in 4.25 in or 5.75 in, 25 per set. For handing prints out one by one."
                  phone={`Plain white, 25 per set${envelopesPrice ? `, from ${envelopesPrice}` : ''}.`}
                />
              </p>
            </div>
            <span className="lnd-arrow-link gft-extra-cta" aria-hidden="true">
              {envelopesPrice ? `From ${envelopesPrice}` : 'See envelopes'}
              <PdpIcon name="arrowRight" size={14} />
            </span>
            <PdpIcon name="chevronRight" size={18} className="gft-extra-chevron" />
          </li>
          <li className="gft-extra">
            <span className="gft-extra-icon" aria-hidden="true">
              <PdpIcon name="send" size={22} />
            </span>
            <div className="gft-extra-copy">
              <h3 className="gft-extra-title">
                <Anchor
                  href={GIFT_CARD_HREF}
                  className="gft-extra-link"
                  onClick={track('gift_card', 'extras')}
                >
                  Gift Cards by email
                </Anchor>
              </h3>
              <p className="gft-extra-desc">
                <Responsive
                  desktop="Pick a design and an amount from $10 to $100. It lands in their inbox in minutes."
                  phone="$10 to $100, in their inbox in minutes."
                />
              </p>
            </div>
            <span className="lnd-arrow-link gft-extra-cta" aria-hidden="true">
              Send a Gift Card
              <PdpIcon name="arrowRight" size={14} />
            </span>
            <PdpIcon name="chevronRight" size={18} className="gft-extra-chevron" />
          </li>
          <li className="gft-extra">
            <span className="gft-extra-icon" aria-hidden="true">
              <PdpIcon name="calendarCheck" size={22} />
            </span>
            <div className="gft-extra-copy">
              <h3 className="gft-extra-title">
                <Anchor
                  href="/shipping"
                  className="gft-extra-link"
                  onClick={track('shipping', 'extras')}
                >
                  Holiday order-by dates
                </Anchor>
              </h3>
              <p className="gft-extra-desc">
                <Responsive
                  desktop="Every product’s production and delivery time, plus the safe date to order for the holidays."
                  phone="The safe date to order for the holidays."
                />
              </p>
            </div>
            <span className="lnd-arrow-link gft-extra-cta" aria-hidden="true">
              See shipping times
              <PdpIcon name="arrowRight" size={14} />
            </span>
            <PdpIcon name="chevronRight" size={18} className="gft-extra-chevron" />
          </li>
        </ul>
      </Container>
    </section>
  );
};

FinishingTouches.propTypes = {
  track: PropTypes.func.isRequired,
};

export default FinishingTouches;
